import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { store } from '../../../../../app/store'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import TableAverageCostBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/averageCost/Table'
import { resetStoreBankAverageCost } from '../../../../companyAnalysis/financial/financialAnalysis/bank/averageCost/store/slice'
import { getBankAverageCostThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/averageCost/store/thunk'
import TrendAverageCostBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/averageCost/trend'
import { EachYear as EachYearBalanceBreakdownBank } from '../../../../companyAnalysis/financial/financialAnalysis/bank/balanceBreakdown/EachYear'
import TableBalanceBreakdownBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/balanceBreakdown/Table'
import { Trend as TrendBalanceBreakdownBank } from '../../../../companyAnalysis/financial/financialAnalysis/bank/balanceBreakdown/Trend'
import { resetStoreBankBalanceBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/bank/balanceBreakdown/store/slice'
import { getBankBalanceBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/balanceBreakdown/store/thunk'
import TableCapitalAndLeverageBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/capitalAndLeverage/Table'
import TrendCapitalAndLeverageBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/capitalAndLeverage/Trend'
import { resetStoreBankCapitalAndLeverage } from '../../../../companyAnalysis/financial/financialAnalysis/bank/capitalAndLeverage/store/slice'
import { getBankCapitalAndLeverageThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/capitalAndLeverage/store/thunk'
import TableCashBreakdownBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/cashFlow/Table'
import { Trend as TrendCashBreakdownBank } from '../../../../companyAnalysis/financial/financialAnalysis/bank/cashFlow/Trend'
import { resetStoreBankCashBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/bank/cashFlow/store/slice'
import { getBankCashBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/cashFlow/store/thunk'
import TableDepositAndCreditBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/depositAndCredit/Table'
import TrendDepositAndCreditBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/depositAndCredit/Trend'
import { resetStoreBankDepositAndCredit } from '../../../../companyAnalysis/financial/financialAnalysis/bank/depositAndCredit/store/slice'
import { getBankDepositAndCreditThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/depositAndCredit/store/thunk'
import { EachYear as EachYearEarningBreakdownBank } from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningBreakdown/EachYear'
import TableEarningBreakdownBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningBreakdown/Table'
import { Trend as TrendEarningBreakdownBank } from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningBreakdown/Trend'
import { resetStoreBankEarningBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningBreakdown/store/slice'
import { getBankEarningBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningBreakdown/store/thunk'
import TableEarningQualityBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningQuality/Table'
import TrendEarningQualityBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningQuality/Trend'
import { resetStoreBankEarningQuality } from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningQuality/store/slice'
import { getBankEarningsQualityThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/earningQuality/store/thunk'
import EachYearFundingStructureBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/fundingStructure/EachYear'
import TableFundingStructureBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/fundingStructure/Table'
import TrendFundingStructureBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/fundingStructure/Trend'
import { resetStoreBankFundingStructure } from '../../../../companyAnalysis/financial/financialAnalysis/bank/fundingStructure/store/slice'
import { getBankFundingStructureThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/fundingStructure/store/thunk'
import TableLiquidityBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/liquidity/Table'
import TrendLiquidityBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/liquidity/Trend'
import { resetStoreBankLiquidity } from '../../../../companyAnalysis/financial/financialAnalysis/bank/liquidity/store/slice'
import { getBankLiquidityThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/liquidity/store/thunk'
import TableLoanBookBreakdownBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/loanBookBreakdown/Table'
import { resetStoreBankLoanBookBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/bank/loanBookBreakdown/store/slice'
import { getBankLoanBookBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/loanBookBreakdown/store/thunk'
import TrendLoanBookBreakdownBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/loanBookBreakdown/trend'
import QuickAssessmentBank from '../../../../companyAnalysis/financial/financialAnalysis/bank/quickAssessment/index'
import { resetStoreBankQuickAssessment } from '../../../../companyAnalysis/financial/financialAnalysis/bank/quickAssessment/store/slice'
import { getBankQuickAssessmentThunk } from '../../../../companyAnalysis/financial/financialAnalysis/bank/quickAssessment/store/thunk'
import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentNonBank,
  typeComponentSecurity,
} from '../../../../companyAnalysis/financial/financialAnalysis/constant'
import EachYearAssetManagementEfficiencyCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/assetManagementEfficiency/EachYear'
import TableAssetManagementEfficiencyCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/assetManagementEfficiency/Table'
import { resetStoreAssetManagementEfficiency } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/assetManagementEfficiency/store/slice'
import { getAssetManagementEfficiencyThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/assetManagementEfficiency/store/thunk'
import TrendAssetManagementEfficiencyCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/assetManagementEfficiency/trend'
import { EachYear as EachYearBalanceBreakdownCorp } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/balanceBreakdown/EachYear'
import TableBalanceBreakdownCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/balanceBreakdown/Table'
import { Trend as TrendBalanceBreakdownCorp } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/balanceBreakdown/Trend'
import { resetStoreCorpBalanceBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/balanceBreakdown/store/slice'
import { getCorpBalanceBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/balanceBreakdown/store/thunk'
import TableCashBreakdownCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/cashBreakdown/Table'
import { Trend as TrendCashBreakdownCorp } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/cashBreakdown/Trend'
import { resetStoreCorpCashBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/cashBreakdown/store/slice'
import { getCorpCashBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/cashBreakdown/store/thunk'
import TableCoverageCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/coverage/Table'
import TrendCoverageCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/coverage/Trend'
import { resetStoreCorpCoverage } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/coverage/store/slice'
import { getCorpCoverageThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/coverage/store/thunk'
import { EachYear as EachYearEarningBreakdownCorp } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/earningBreakdown/EachYear'
import TableEarningBreakdownCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/earningBreakdown/Table'
import { Trend as TrendEarningBreakdownCorp } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/earningBreakdown/Trend'
import { resetStoreCorpEarningBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/earningBreakdown/store/slice'
import { getCorpEarningBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/earningBreakdown/store/thunk'
import EachYearLiquidityCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/liquidity/EachYear'
import TableLiquidityCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/liquidity/Table'
import TrendLiquidityCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/liquidity/Trend'
import { resetStoreCorpLiquidity } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/liquidity/store/slice'
import { getCorpLiquidityThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/liquidity/store/thunk'
import EachYearProfitabilityCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/profitability/EachYear'
import TableProfitabilityCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/profitability/Table'
import TrendProfitabilityCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/profitability/Trend'
import { resetStoreProfitability } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/profitability/store/slice'
import { getProfitabilityThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/profitability/store/thunk'
import QuickAssessmentCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/quickAssessment/index'
import { resetStoreQuickAssessmentCorporate } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/quickAssessment/store/slice'
import { getQuickAssessmentCorporateThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/quickAssessment/store/thunk'
import EachYearRoaAndRoeCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/roaAndRoe/EachYear'
import TableRoaAndRoeCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/roaAndRoe/Table'
import { resetStoreRoaAndRoe } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/roaAndRoe/store/slice'
import { getRoaAndRoeThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/roaAndRoe/store/thunk'
import TrendRoaAndRoeCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/roaAndRoe/trend'
import EachYearSolvencyCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/solvency/EachYear'
import TableSolvencyCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/solvency/Table'
import { resetStoreCorpSolvency } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/solvency/store/slice'
import { getCorpSolvencyThunk } from '../../../../companyAnalysis/financial/financialAnalysis/corporate/solvency/store/thunk'
import TrendSolvencyCorp from '../../../../companyAnalysis/financial/financialAnalysis/corporate/solvency/trend'
import '../../../../companyAnalysis/financial/financialAnalysis/i18n'
import TableAverageCostNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/averageCost/Table'
import { resetStoreNonBankAverageCost } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/averageCost/store/slice'
import { getNonBankAverageCostThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/averageCost/store/thunk'
import TrendAverageCostNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/averageCost/trend'
import { EachYear as EachYearBalanceBreakdownNonBank } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/balanceBreakdown/EachYear'
import TableBalanceBreakdownNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/balanceBreakdown/Table'
import { Trend as TrendBalanceBreakdownNonBank } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/balanceBreakdown/Trend'
import { resetStoreNonBankBalanceBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/balanceBreakdown/store/slice'
import { getNonBankBalanceBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/balanceBreakdown/store/thunk'
import TableCapitalAndLeverageNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/capitalAndLeverage/Table'
import TrendCapitalAndLeverageNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/capitalAndLeverage/Trend'
import { resetStoreNonBankCapitalAndLeverage } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/capitalAndLeverage/store/slice'
import { getNonBankCapitalAndLeverageThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/capitalAndLeverage/store/thunk'
import TableCashBreakdownNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/cashFlow/Table'
import { Trend as TrendCashBreakdownNonBank } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/cashFlow/Trend'
import { resetStoreNonBankCashBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/cashFlow/store/slice'
import { getNonBankCashBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/cashFlow/store/thunk'
import TableDepositAndCreditNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/depositAndCredit/Table'
import TrendDepositAndCreditNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/depositAndCredit/Trend'
import { resetStoreNonBankDepositAndCredit } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/depositAndCredit/store/slice'
import { getNonBankDepositAndCreditThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/depositAndCredit/store/thunk'
import { EachYear as EachYearEarningBreakdownNonBank } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningBreakdown/EachYear'
import TableEarningBreakdownNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningBreakdown/Table'
import { Trend as TrendEarningBreakdownNonBank } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningBreakdown/Trend'
import { resetStoreNonBankEarningBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningBreakdown/store/slice'
import { getNonBankEarningBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningBreakdown/store/thunk'
import TableEarningQualityNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningQuality/Table'
import TrendEarningQualityNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningQuality/Trend'
import { resetStoreNonBankEarningQuality } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningQuality/store/slice'
import { getNonBankEarningsQualityThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/earningQuality/store/thunk'
import EachYearFundingStructureNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/fundingStructure/EachYear'
import TableFundingStructureNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/fundingStructure/Table'
import TrendFundingStructureNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/fundingStructure/Trend'
import { resetStoreNonBankFundingStructure } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/fundingStructure/store/slice'
import { getNonBankFundingStructureThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/fundingStructure/store/thunk'
import TableLiquidityNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/liquidity/Table'
import TrendLiquidityNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/liquidity/Trend'
import { resetStoreNonBankLiquidity } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/liquidity/store/slice'
import { getNonBankLiquidityThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/liquidity/store/thunk'
import TableLoanBookBreakdownNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/loanBookBreakdown/Table'
import { resetStoreNonBankLoanBookBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/loanBookBreakdown/store/slice'
import { getNonBankLoanBookBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/loanBookBreakdown/store/thunk'
import TrendLoanBookBreakdownNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/loanBookBreakdown/trend'
import QuickAssessmentNonBank from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/quickAssessment/index'
import { resetStoreNonBankQuickAssessment } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/quickAssessment/store/slice'
import { getNonBankQuickAssessmentThunk } from '../../../../companyAnalysis/financial/financialAnalysis/nonBank/quickAssessment/store/thunk'
import { EachYear as EachYearBalanceBreakdownSecu } from '../../../../companyAnalysis/financial/financialAnalysis/security/balanceBreakdown/EachYear'
import TableBalanceBreakdownSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/balanceBreakdown/Table'
import { Trend as TrendBalanceBreakdownSecu } from '../../../../companyAnalysis/financial/financialAnalysis/security/balanceBreakdown/Trend'
import { resetStoreSecuBalanceBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/security/balanceBreakdown/store/slice'
import { getSecuBalanceBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/balanceBreakdown/store/thunk'
import TableBusinessPositionSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/businessPosition/Table'
import TrendBusinessPositionSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/businessPosition/Trend'
import { resetStoreSecuBusinessPosition } from '../../../../companyAnalysis/financial/financialAnalysis/security/businessPosition/store/slice'
import { getSecuBusinessPositionThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/businessPosition/store/thunk'
import TableCashBreakdownSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/cashFlow/Table'
import { Trend as TrendCashBreakdownSecu } from '../../../../companyAnalysis/financial/financialAnalysis/security/cashFlow/Trend'
import { resetStoreSecuCashBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/security/cashFlow/store/slice'
import { getSecuCashBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/cashFlow/store/thunk'
import { EachYear as EachYearEarningBreakdownSecu } from '../../../../companyAnalysis/financial/financialAnalysis/security/earningBreakdown/EachYear'
import TableEarningBreakdownSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/earningBreakdown/Table'
import { Trend as TrendEarningBreakdownSecu } from '../../../../companyAnalysis/financial/financialAnalysis/security/earningBreakdown/Trend'
import { resetStoreSecuEarningBreakdown } from '../../../../companyAnalysis/financial/financialAnalysis/security/earningBreakdown/store/slice'
import { getSecuEarningBreakdownThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/earningBreakdown/store/thunk'
import TableEarningQualitySecu from '../../../../companyAnalysis/financial/financialAnalysis/security/earningQuality/Table'
import { resetStoreSecuEarningQuality } from '../../../../companyAnalysis/financial/financialAnalysis/security/earningQuality/store/slice'
import { getSecuEarningQualityThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/earningQuality/store/thunk'
import TrendEarningQualitySecu from '../../../../companyAnalysis/financial/financialAnalysis/security/earningQuality/trend'
import EachYearFinancialAssetSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/financialAsset/EachYear'
import TableFinancialAssetSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/financialAsset/Table'
import TrendFinancialAssetSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/financialAsset/Trend'
import { resetStoreSecuFinancialAssets } from '../../../../companyAnalysis/financial/financialAnalysis/security/financialAsset/store/slice'
import { getSecuFinancialAssetsThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/financialAsset/store/thunk'
import TableFundingAndLiquiditySecu from '../../../../companyAnalysis/financial/financialAnalysis/security/fundingAndLiquidity/Table'
import TrendFundingAndLiquiditySecu from '../../../../companyAnalysis/financial/financialAnalysis/security/fundingAndLiquidity/Trend'
import { resetStoreSecuFundingAndLiquidity } from '../../../../companyAnalysis/financial/financialAnalysis/security/fundingAndLiquidity/store/slice'
import { getSecuFundingAndLiquidityThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/fundingAndLiquidity/store/thunk'
import TableLeverageSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/leverage/Table'
import { resetStoreSecuLeverage } from '../../../../companyAnalysis/financial/financialAnalysis/security/leverage/store/slice'
import { getSecuLeverageThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/leverage/store/thunk'
import TrendLeverageSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/leverage/trend'
import EachYearOperatingIncomeSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/operatingIncome/EachYear'
import TableOperatingIncomeSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/operatingIncome/Table'
import { resetStoreSecuOperatingIncome } from '../../../../companyAnalysis/financial/financialAnalysis/security/operatingIncome/store/slice'
import { getSecuOperatingIncomeThunk } from '../../../../companyAnalysis/financial/financialAnalysis/security/operatingIncome/store/thunk'
import TrendOperatingIncomeSecu from '../../../../companyAnalysis/financial/financialAnalysis/security/operatingIncome/trend'
import { selectSliceFinancialAnalysis } from '../../../../companyAnalysis/financial/financialAnalysis/store/slice'
import { getUnique } from '../../../../helpers/common'
import { COMPANY_TYPES } from '../../../../utils/common'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
  VIEW_BY,
} from '../../constant'
import Items from '../../preferenceSetting/detailTemplate/settingPanel/information/Items'
import { selectYearReport } from '../../preferenceSetting/detailTemplate/store/slice'

const PANELS = {
  // corporate
  QUICK_ASSESSMENT_CORP: typeComponentCorporate.QUICK_ASSESSMENT,
  PROFITABILITY_CORP: typeComponentCorporate.PROFITABILITY,
  ROA_AND_ROE_CORP: typeComponentCorporate.ROA_AND_ROE,
  ASSET_MANAGEMENT_EFFICIENCY_CORP:
    typeComponentCorporate.ASSET_MANAGEMENT_EFFICIENCY,
  LIQUIDITY_CORP: typeComponentCorporate.LIQUIDITY,
  SOLVENCY_CORP: typeComponentCorporate.SOLVENCY,
  COVERAGE_CORP: typeComponentCorporate.COVERAGE,
  BALANCE_SHEET_BREAKDOWN_CORP: typeComponentCorporate.BALANCE_BREAKDOWN,
  EARNINGS_BREAKDOWN_CORP: typeComponentCorporate.EARNING_BREAKDOWN,
  CASH_FLOW_STRUCTURE_CORP: typeComponentCorporate.CASH_BREAKDOWN,
  // bank
  QUICK_ASSESSMENT_BANK: typeComponentBank.QUICK_ASSESSMENT,
  LOAN_BOOK_BREAKDOWN_AND_COVERAGE_BANK: typeComponentBank.LOAN_BOOK_BREAKDOWN,
  DEPOSIT_AND_CREDIT_BANK: typeComponentBank.DEPOSIT_AND_CREDIT,
  AVERAGE_COST_BANK: typeComponentBank.AVERAGE_COST,
  EARNINGS_QUALITY_BANK: typeComponentBank.EARNING_QUALITY,
  CAPITAL_AND_LEVERAGE_BANK: typeComponentBank.CAPITAL_AND_LEVERAGE,
  LIQUIDITY_BANK: typeComponentBank.LIQUIDITY,
  FUNDING_STRUCTURE_BANK: typeComponentBank.FUNDING_STRUCTURE,
  BALANCE_SHEET_BREAKDOWN_BANK: typeComponentBank.BALANCE_BREAKDOWN,
  EARNINGS_BREAKDOWN_BANK: typeComponentBank.EARNING_BREAKDOWN,
  CASH_FLOW_STRUCTURE_BANK: typeComponentBank.CASH_FLOW,
  // non bank
  QUICK_ASSESSMENT_NON_BANK: typeComponentNonBank.QUICK_ASSESSMENT,
  LOAN_BOOK_BREAKDOWN_AND_COVERAGE_NON_BANK:
    typeComponentNonBank.LOAN_BOOK_BREAKDOWN,
  DEPOSIT_AND_CREDIT_NON_BANK: typeComponentNonBank.DEPOSIT_AND_CREDIT,
  AVERAGE_COST_NON_BANK: typeComponentNonBank.AVERAGE_COST,
  EARNINGS_QUALITY_NON_BANK: typeComponentNonBank.EARNING_QUALITY,
  CAPITAL_AND_LEVERAGE_NON_BANK: typeComponentNonBank.CAPITAL_AND_LEVERAGE,
  LIQUIDITY_NON_BANK: typeComponentNonBank.LIQUIDITY,
  FUNDING_STRUCTURE_NON_BANK: typeComponentNonBank.FUNDING_STRUCTURE,
  BALANCE_SHEET_BREAKDOWN_NON_BANK: typeComponentNonBank.BALANCE_BREAKDOWN,
  EARNINGS_BREAKDOWN_NON_BANK: typeComponentNonBank.EARNING_BREAKDOWN,
  CASH_FLOW_STRUCTURE_NON_BANK: typeComponentNonBank.CASH_FLOW,
  // security
  OPERATING_SALES_SECU: typeComponentSecurity.OPERATING_INCOME,
  BUSINESS_POSITION_SECU: typeComponentSecurity.BUSINESS_POSITION,
  FINANCIAL_ASSETS_SECU: typeComponentSecurity.FINANCIAL_ASSET,
  EARNING_QUALITY_SECU: typeComponentSecurity.EARNING_QUALITY,
  LEVERAGE_SECU: typeComponentSecurity.LEVERAGE,
  FUNDING_AND_LIQUIDITY_SECU: typeComponentSecurity.FUNDING_AND_LIQUIDITY,
  BALANCE_SHEET_BREAKDOWN_SECU: typeComponentSecurity.BALANCE_BREAKDOWN,
  EARNINGS_BREAKDOWN_SECU: typeComponentSecurity.EARNING_BREAKDOWN,
  CASH_FLOW_STRUCTURE_SECU: typeComponentSecurity.CASH_FLOW,
}

export const getPanelListFinancialAnalysis = (companyType) => {
  const getChildren = () => {
    switch (companyType) {
      case COMPANY_TYPES.CORPORATE:
        return [
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.QUICK_ASSESSMENT_CORP,
            label: 'dynamicReport.QUICK_ASSESSMENT',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.PROFITABILITY_CORP,
            label: 'dynamicReport.PROFITABILITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: [
                'FA165',
                'RT0048',
                'RT0050',
                'RT0051',
                'RT0052',
                'RT0054',
              ],
              checkTable: [
                'FA165',
                'RT0048',
                'RT0049',
                'RT0050',
                'RTI0050',
                'RT0051',
                'RTI0051',
                'RT0052',
                'RTI0052',
                'RT0054',
                'RTI0054',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.ROA_AND_ROE_CORP,
            label: 'dynamicReport.ROA_AND_ROE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: ['RT0060', 'RT0059'],
              checkTable: [
                'RT0060',
                'RTI0060',
                'RT0059',
                'RTI0059',
                'RT0035',
                'RT0054',
                'RT0003',
                'FA001',
                'RT0065',
                'RT0052',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.ASSET_MANAGEMENT_EFFICIENCY_CORP,
            label: 'dynamicReport.ASSET_MANAGEMENT_EFFICIENCY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              checkTable: [
                'RT0009',
                'RTI0009',
                'RT0011',
                'RTI0011',
                'RT0013',
                'RTI0013',
                'RT0015',
                'RTI0015',
                'RT0006',
                'RT0003',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.LIQUIDITY_CORP,
            label: 'dynamicReport.LIQUIDITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: ['RT0020', 'RT0019', 'RT0018'],
              checkTable: [
                'RT0020',
                'RTI0020',
                'RT0019',
                'RTI0019',
                'RT0018',
                'RTI0018',
                'RT0001',
                'RT0040',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.SOLVENCY_CORP,
            label: 'dynamicReport.SOLVENCY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: [
                'RT0027',
                'RT0034',
                'RTI0027',
                'RTI0034',
                'RT0037',
                'RTI0037',
              ],
              checkTable: [
                'RT0027',
                'RTI0027',
                'RT0034',
                'RTI0034',
                'RT0037',
                'RTI0037',
                'FA002',
                'FA160',
                'FA159',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.COVERAGE_CORP,
            label: 'dynamicReport.COVERAGE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['RT0044', 'RT0045', 'RT0046', 'RT0047'],
              checkTable: ['RT0044', 'RT0045', 'RT0046', 'RT0047'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.BALANCE_SHEET_BREAKDOWN_CORP,
            label: 'dynamicReport.BALANCE_SHEET_BREAKDOWN',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: [
                'BS2',
                'FA004',
                'BS18',
                'FA005',
                'FA006',
                'RT0172',
                'FA013',
                'FA016',
                'FA015',
                'FA014',
                'FA017',
                'FA018',
                'FA024',
                'BS109',
                'FA025',
                'RT0173',
              ],
              chartEachYear: [1, 2, 3],
              tabTable: 0,
              checkTable1: [
                'BS2',
                'FA003',
                'FA004',
                'BS18',
                'FA005',
                'FA006',
                'BS64',
                'RT0172',
              ],
              checkTable2: [
                'FA013',
                'FA014',
                'FA015',
                'FA016',
                'FA017',
                'BS65',
                'FA018',
              ],
              checkTable3: ['FA024', 'BS109', 'FA025', 'BS95', 'RT0173'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.EARNINGS_BREAKDOWN_CORP,
            label: 'dynamicReport.EARNINGS_BREAKDOWN',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: [
                'FA165',
                'FA164',
                'FA029',
                'FA189',
                'FA168',
                'FA162',
                'FA167',
                'FA166',
              ],
              checkTable: [
                'FA165',
                'FA164',
                'FA029',
                'FA189',
                'FA168',
                'FA162',
                'FA167',
                'FA161',
                'FA166',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.CASH_FLOW_STRUCTURE_CORP,
            label: 'dynamicReport.CASH_FLOW_STRUCTURE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['CF19', 'CF30', 'CF37', 'CF38'],
              checkTable: ['CF19', 'CF30', 'CF37', 'CF38'],
            },
          },
        ]
      case COMPANY_TYPES.BANK:
        return [
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.QUICK_ASSESSMENT_BANK,
            label: 'dynamicReport.QUICK_ASSESSMENT',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.LOAN_BOOK_BREAKDOWN_AND_COVERAGE_BANK,
            label: 'dynamicReport.LOAN_BOOK_BREAKDOWN_AND_COVERAGE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: [
                'NB66',
                'NB67',
                'NB68',
                'NB69',
                'NB70',
                'FA146',
                'FA147',
                'NB72',
                'NB73',
                'NB74',
                'top3Sector',
                'lossToNpl',
                'lossToTotalLoan',
              ],
              checkTable: [
                'NB66',
                'NB67',
                'NB68',
                'NB69',
                'NB70',
                'FA146',
                'FA147',
                'NB72',
                'NB73',
                'NB74',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.DEPOSIT_AND_CREDIT_BANK,
            label: 'dynamicReport.DEPOSIT_AND_CREDIT',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['BS178', 'BS158', 'RT0297', 'RT0296'],
              checkTable: ['BS178', 'BS158', 'RT0297', 'RT0296'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.AVERAGE_COST_BANK,
            label: 'dynamicReport.AVERAGE_COST',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['FA149', 'RT0239', 'FA061'],
              checkTable: ['FA149', 'RT0239', 'FA061', 'FA169'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.EARNINGS_QUALITY_BANK,
            label: 'dynamicReport.EARNINGS_QUALITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['FA150', 'RT0252', 'RT0060', 'RT0059'],
              checkTable: ['FA150', 'RT0252', 'RT0060', 'RT0059'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.CAPITAL_AND_LEVERAGE_BANK,
            label: 'dynamicReport.CAPITAL_AND_LEVERAGE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['RT0248', 'NB219', 'FA060'],
              checkTable: ['RT0248', 'NB219', 'FA060'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.LIQUIDITY_BANK,
            label: 'dynamicReport.LIQUIDITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['RT0277', 'FA111', 'RT0318', 'FA149'],
              checkTable: ['RT0277', 'FA111', 'RT0318', 'FA149'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.FUNDING_STRUCTURE_BANK,
            label: 'dynamicReport.FUNDING_STRUCTURE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: ['BS178', 'BS174', 'BS175', 'BS180', 'BS181', 'FA031'],
              checkTable: [
                'BS178',
                'BS174',
                'BS175',
                'BS180',
                'BS181',
                'FA156',
                'FA031',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.BALANCE_SHEET_BREAKDOWN_BANK,
            label: 'dynamicReport.BALANCE_SHEET_BREAKDOWN',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: [
                'BS2',
                'FA037',
                'FA038',
                'BS158',
                'FA039',
                'FA040',
                'RT0296',
                'RT0172',
                'BS174',
                'BS175',
                'BS178',
                'BS181',
                'FA047',
                'FA048',
                'BS186',
                'BS187',
                'BS109',
                'FA054',
                'RT0173',
              ],
              chartEachYear: [1, 2, 3],
              tabTable: 0,
              checkTable1: [
                'BS2',
                'FA037',
                'FA038',
                'BS158',
                'FA039',
                'FA040',
                'BS64',
                'RT0296',
                'RT0172',
              ],
              checkTable2: [
                'BS174',
                'BS175',
                'BS178',
                'BS181',
                'FA047',
                'BS65',
                'FA048',
              ],
              checkTable3: [
                'BS186',
                'BS187',
                'BS109',
                'FA054',
                'BS95',
                'RT0173',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.EARNINGS_BREAKDOWN_BANK,
            label: 'dynamicReport.EARNINGS_BREAKDOWN',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: ['IS27', 'IS30', 'FA059', 'IS39', 'IS41', 'IS16'],
              checkTable: ['IS27', 'IS30', 'FA059', 'IS39', 'IS41', 'IS16'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.CASH_FLOW_STRUCTURE_BANK,
            label: 'dynamicReport.CASH_FLOW_STRUCTURE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['CF19', 'CF30', 'CF37', 'CF38'],
              checkTable: ['CF19', 'CF30', 'CF37', 'CF38'],
            },
          },
        ]
      case COMPANY_TYPES.NON_BANK:
        return [
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.QUICK_ASSESSMENT_NON_BANK,
            label: 'dynamicReport.QUICK_ASSESSMENT',
            type: TYPE_ITEM_SETTING.PANEL,
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.LOAN_BOOK_BREAKDOWN_AND_COVERAGE_NON_BANK,
            label: 'dynamicReport.LOAN_BOOK_BREAKDOWN_AND_COVERAGE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: [
                'NB66',
                'NB67',
                'NB68',
                'NB69',
                'NB70',
                'FA146',
                'FA147',
                'NB72',
                'NB73',
                'NB74',
                'top3Sector',
                'lossToNpl',
                'lossToTotalLoan',
              ],
              checkTable: [
                'NB66',
                'NB67',
                'NB68',
                'NB69',
                'NB70',
                'FA146',
                'FA147',
                'NB72',
                'NB73',
                'NB74',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.DEPOSIT_AND_CREDIT_NON_BANK,
            label: 'dynamicReport.DEPOSIT_AND_CREDIT',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['BS178', 'BS158', 'RT0297', 'RT0296'],
              checkTable: ['BS178', 'BS158', 'RT0297', 'RT0296'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.AVERAGE_COST_NON_BANK,
            label: 'dynamicReport.AVERAGE_COST',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['FA149', 'RT0239', 'FA061'],
              checkTable: ['FA149', 'RT0239', 'FA061', 'FA169'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.EARNINGS_QUALITY_NON_BANK,
            label: 'dynamicReport.EARNINGS_QUALITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['FA150', 'RT0252', 'RT0060', 'RT0059'],
              checkTable: ['FA150', 'RT0252', 'RT0060', 'RT0059'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.CAPITAL_AND_LEVERAGE_NON_BANK,
            label: 'dynamicReport.CAPITAL_AND_LEVERAGE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['RT0248', 'NB219', 'FA060'],
              checkTable: ['RT0248', 'NB219', 'FA060'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.LIQUIDITY_NON_BANK,
            label: 'dynamicReport.LIQUIDITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['RT0277', 'FA111', 'RT0318', 'FA149'],
              checkTable: ['RT0277', 'FA111', 'RT0318', 'FA149'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.FUNDING_STRUCTURE_NON_BANK,
            label: 'dynamicReport.FUNDING_STRUCTURE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: ['BS178', 'BS174', 'BS175', 'BS180', 'BS181', 'FA031'],
              checkTable: [
                'BS178',
                'BS174',
                'BS175',
                'BS180',
                'BS181',
                'FA156',
                'FA031',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.BALANCE_SHEET_BREAKDOWN_NON_BANK,
            label: 'dynamicReport.BALANCE_SHEET_BREAKDOWN',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: [
                'BS2',
                'FA037',
                'FA038',
                'BS158',
                'FA039',
                'FA040',
                'RT0296',
                'RT0172',
                'BS174',
                'BS175',
                'BS178',
                'BS181',
                'FA047',
                'FA048',
                'BS186',
                'BS187',
                'BS109',
                'FA054',
                'RT0173',
              ],
              chartEachYear: [1, 2, 3],
              tabTable: 0,
              checkTable1: [
                'BS2',
                'FA037',
                'FA038',
                'BS158',
                'FA039',
                'FA040',
                'BS64',
                'RT0296',
                'RT0172',
              ],
              checkTable2: [
                'BS174',
                'BS175',
                'BS178',
                'BS181',
                'FA047',
                'BS65',
                'FA048',
              ],
              checkTable3: [
                'BS186',
                'BS187',
                'BS109',
                'FA054',
                'BS95',
                'RT0173',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.EARNINGS_BREAKDOWN_NON_BANK,
            label: 'dynamicReport.EARNINGS_BREAKDOWN',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: ['IS27', 'IS30', 'FA059', 'IS39', 'IS41', 'IS16'],
              checkTable: ['IS27', 'IS30', 'FA059', 'IS39', 'IS41', 'IS16'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.CASH_FLOW_STRUCTURE_NON_BANK,
            label: 'dynamicReport.CASH_FLOW_STRUCTURE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['CF19', 'CF30', 'CF37', 'CF38'],
              checkTable: ['CF19', 'CF30', 'CF37', 'CF38'],
            },
          },
        ]
      case COMPANY_TYPES.SECURITIES:
        return [
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.OPERATING_SALES_SECU,
            label: 'dynamicReport.OPERATING_SALES',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: [
                'FA062',
                'IS111',
                'IS114',
                'FA063',
                'FA064',
                'IS106',
                'IS110',
                'IS112',
              ],
              chartEachYear: [1, 2],
              tabTable: 0,
              checkTable1: ['IS3', 'FA062', 'IS111', 'IS114', 'FA063', 'FA064'],
              checkTable2: ['IS106', 'IS110', 'IS112'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.BUSINESS_POSITION_SECU,
            label: 'dynamicReport.BUSINESS_POSITION',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['IS3', 'BS64', 'FA073', 'FA074'],
              checkTable: ['IS3', 'BS64', 'FA073', 'FA074'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.FINANCIAL_ASSETS_SECU,
            label: 'dynamicReport.FINANCIAL_ASSETS',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: ['BS249', 'FA075', 'FA076', 'FA077'],
              checkTable: [
                'BS249',
                'FA075',
                'FA076',
                'FA077',
                'FA158',
                'FA112',
                'FA113',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.EARNING_QUALITY_SECU,
            label: 'dynamicReport.EARNING_QUALITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              checkTable: [
                'FA082',
                'RT0060',
                'FA083',
                'RT0059',
                'RTI0059',
                'RTI0060',
              ],
              check: ['FA082', 'RT0060', 'FA083', 'RT0059'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.LEVERAGE_SECU,
            label: 'dynamicReport.LEVERAGE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              checkTable: ['RT0034', 'FA084'],
              check: ['RT0034', 'FA084'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.FUNDING_AND_LIQUIDITY_SECU,
            label: 'dynamicReport.FUNDING_AND_LIQUIDITY',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['RT0020', 'FA085', 'FA086', 'FA087', 'FA088'],
              checkTable: ['RT0020', 'FA085', 'FA086', 'FA087', 'FA088'],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.BALANCE_SHEET_BREAKDOWN_SECU,
            label: 'dynamicReport.BALANCE_SHEET_BREAKDOWN',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: [
                'FA090',
                'BS250',
                'BS265',
                'BS36',
                'BS46',
                'BS49',
                'FA091',
                'RT0172',
                'BS66',
                'BS81',
                'FA099',
                'BS293',
                'BS294',
                'BS138',
                'BS109',
                'FA102',
                'RT0173',
              ],
              chartEachYear: [1, 2, 3],
              tabTable: 0,
              checkTable1: [
                'FA090',
                'BS250',
                'BS265',
                'BS36',
                'BS46',
                'BS49',
                'FA091',
                'BS64',
                'RT0172',
              ],
              checkTable2: ['BS66', 'BS81', 'BS65', 'FA099'],
              checkTable3: [
                'BS293',
                'BS294',
                'BS138',
                'BS109',
                'FA102',
                'BS95',
                'RT0173',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.EARNINGS_BREAKDOWN_SECU,
            label: 'dynamicReport.EARNINGS_BREAKDOWN',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.EACH_YEAR,
              check: [
                'IS3',
                'IS6',
                'IS7',
                'IS4',
                'FA089',
                'IS13',
                'IS14',
                'IS16',
              ],
              checkTable: [
                'IS3',
                'IS6',
                'IS7',
                'IS4',
                'FA089',
                'IS13',
                'IS14',
                'IS15',
                'IS16',
              ],
            },
          },
          {
            screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
            panel: PANELS.CASH_FLOW_STRUCTURE_SECU,
            label: 'dynamicReport.CASH_FLOW_STRUCTURE',
            type: TYPE_ITEM_SETTING.PANEL,
            setting: {
              viewBy: VIEW_BY.TREND,
              check: ['CF19', 'CF30', 'CF37', 'CF38'],
              checkTable: ['CF19', 'CF30', 'CF37', 'CF38'],
            },
          },
        ]
      default:
        return []
    }
  }

  return [
    {
      label: 'dynamicReport.FINANCIAL_ANALYSIS',
      children: getChildren(),
    },
  ]
}

const detailItemCheck = { key: 'check', type: TYPE_INFORMATION_PANEL.CHECKBOX }

const detailItemCheckTable = {
  key: 'checkTable',
  type: TYPE_INFORMATION_PANEL.CHECKBOX,
}

const detailItemCheckRequire = {
  key: 'check',
  type: TYPE_INFORMATION_PANEL.CHECKBOX,
  isRequire: true,
}

const SelectYear = ({ setValue, setting }) => {
  const yearReport = useSelector(selectYearReport)

  if (!yearReport) {
    return (
      <div className="dFlex alignItemsCenter mt1">
        <Icon className="icon-info-circle pr1" style={{ color: '#9C9C9C' }} />
        <Element elementName="span" style={{ color: '#9C9C9C' }}>
          <Translate value="dynamicReport.YEAR_REPORT_WARNING" />
        </Element>
      </div>
    )
  }

  return (
    <Items
      items={yearReport.map((year) => ({
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: year,
        title: String(year),
        key: 'year',
        style: { paddingRight: 16 },
      }))}
      setting={setting}
      setValue={setValue}
      isInline
      style={{ paddingLeft: 0, marginTop: 0 }}
    />
  )
}

const CheckboxParent = ({
  setValue,
  setting,
  keySetting,
  title,
  children = [],
}) => {
  const checked = setting[keySetting] || []
  const isChecked = children.some((id) => checked.includes(id))

  const onChange = (val) => {
    if (val) {
      setValue(`setting.${keySetting}`, [
        ...checked,
        ...children.filter((item) => !checked.includes(item)),
      ])
    } else {
      const newValue = checked.filter((item) => !children.includes(item))
      if (newValue.length) {
        setValue(`setting.${keySetting}`, newValue)
      }
    }
  }

  return (
    <Checkbox
      title={title}
      isI18n
      isCheckOnClickText
      style={{ paddingLeft: 6 }}
      checked={isChecked}
      onChange={onChange}
    />
  )
}

export const getPanelFinancialAnalysis = (panel, viewBy) => {
  switch (panel) {
    // corporate
    case PANELS.QUICK_ASSESSMENT_CORP:
      return {
        renderComponent: () => <QuickAssessmentCorp isDynamicReport />,
        width: 900,
        thunk: [
          ({ companyInfo, settingFs }) =>
            getQuickAssessmentCorporateThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreQuickAssessmentCorporate())
        },
      }
    case PANELS.PROFITABILITY_CORP:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendProfitabilityCorp isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearProfitabilityCorp isDynamicReport year={year} />
          ) : (
            <TableProfitabilityCorp isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getProfitabilityThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreProfitability())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'FA165', ...detailItemCheck },
            { value: 'RT0048', ...detailItemCheck },
            { value: 'RT0050', ...detailItemCheck },
            { value: 'RT0051', ...detailItemCheck },
            { value: 'RT0052', ...detailItemCheck },
            { value: 'RT0054', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'FA151', ...detailItemCheckRequire },
                { value: 'RT0050', ...detailItemCheckRequire },
                { value: 'RTI0050', ...detailItemCheckRequire },
                { value: 'RT0051', ...detailItemCheckRequire },
                { value: 'RTI0051', ...detailItemCheckRequire },
                { value: 'RT0052', ...detailItemCheckRequire },
                { value: 'RTI0052', ...detailItemCheckRequire },
                { value: 'RT0054', ...detailItemCheckRequire },
                { value: 'RTI0054', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'FA165', ...detailItemCheckTable },
            { value: 'RT0048', ...detailItemCheckTable },
            { value: 'RT0049', ...detailItemCheckTable },
            { value: 'RT0050', ...detailItemCheckTable },
            { value: 'RTI0050', ...detailItemCheckTable },
            { value: 'RT0051', ...detailItemCheckTable },
            { value: 'RTI0051', ...detailItemCheckTable },
            { value: 'RT0052', ...detailItemCheckTable },
            { value: 'RTI0052', ...detailItemCheckTable },
            { value: 'RT0054', ...detailItemCheckTable },
            { value: 'RTI0054', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Profitability',
        },
      }
    case PANELS.ROA_AND_ROE_CORP:
      return {
        renderComponent: ({ setting: { viewBy, year, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendRoaAndRoeCorp isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearRoaAndRoeCorp isDynamicReport year={year} />
          ) : (
            <TableRoaAndRoeCorp isDynamicReport checkTable={checkTable} />
          ),
        width: 820,
        thunk: [
          ({ companyInfo, settingFs }) =>
            getRoaAndRoeThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreRoaAndRoe())
        },
        isWaitForMount: [VIEW_BY.TREND, VIEW_BY.TABLE].includes(viewBy),
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0060', ...detailItemCheck },
            { value: 'RT0059', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'RT0060', ...detailItemCheckRequire },
                { value: 'RT0059', ...detailItemCheckRequire },
                { value: 'RT0035', ...detailItemCheckRequire },
                { value: 'RT0054', ...detailItemCheckRequire },
                { value: 'RT0003', ...detailItemCheckRequire },
                { value: 'FA001', ...detailItemCheckRequire },
                { value: 'RT0065', ...detailItemCheckRequire },
                { value: 'RT0052', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0060', ...detailItemCheckTable },
            { value: 'RTI0060', ...detailItemCheckTable },
            { value: 'RT0059', ...detailItemCheckTable },
            { value: 'RTI0059', ...detailItemCheckTable },
            { value: 'RT0035', ...detailItemCheckTable },
            { value: 'RT0054', ...detailItemCheckTable },
            { value: 'RT0003', ...detailItemCheckTable },
            { value: 'FA001', ...detailItemCheckTable },
            { value: 'RT0065', ...detailItemCheckTable },
            { value: 'RT0052', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'RoaAndRoe',
        },
      }
    case PANELS.ASSET_MANAGEMENT_EFFICIENCY_CORP:
      return {
        renderComponent: ({ setting: { viewBy, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendAssetManagementEfficiencyCorp isDynamicReport />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearAssetManagementEfficiencyCorp
              isDynamicReport
              year={year}
            />
          ) : (
            <TableAssetManagementEfficiencyCorp
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        isFixSvg: viewBy === VIEW_BY.EACH_YEAR,
        thunk: [
          ({ companyInfo, settingFs }) =>
            getAssetManagementEfficiencyThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreAssetManagementEfficiency())
        },
        isWaitForMount: [VIEW_BY.TREND, VIEW_BY.TABLE].includes(viewBy),
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0009', ...detailItemCheckRequire },
            { value: 'RTI0009', ...detailItemCheckRequire },
            { value: 'RT0011', ...detailItemCheckRequire },
            { value: 'RTI0011', ...detailItemCheckRequire },
            { value: 'RT0013', ...detailItemCheckRequire },
            { value: 'RTI0013', ...detailItemCheckRequire },
            { value: 'RT0015', ...detailItemCheckRequire },
            { value: 'RTI0015', ...detailItemCheckRequire },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'RT0009', ...detailItemCheckRequire },
                { value: 'RTI0009', ...detailItemCheckRequire },
                { value: 'RT0011', ...detailItemCheckRequire },
                { value: 'RTI0011', ...detailItemCheckRequire },
                { value: 'RT0013', ...detailItemCheckRequire },
                { value: 'RTI0013', ...detailItemCheckRequire },
                { value: 'RT0015', ...detailItemCheckRequire },
                { value: 'RTI0015', ...detailItemCheckRequire },
                { value: 'RT0006', ...detailItemCheckRequire },
                { value: 'RT0003', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0009', ...detailItemCheckTable },
            { value: 'RTI0009', ...detailItemCheckTable },
            { value: 'RT0011', ...detailItemCheckTable },
            { value: 'RTI0011', ...detailItemCheckTable },
            { value: 'RT0013', ...detailItemCheckTable },
            { value: 'RTI0013', ...detailItemCheckTable },
            { value: 'RT0015', ...detailItemCheckTable },
            { value: 'RTI0015', ...detailItemCheckTable },
            { value: 'RT0006', ...detailItemCheckTable },
            { value: 'RT0003', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'AssetManagementEfficiency',
        },
      }
    case PANELS.LIQUIDITY_CORP:
      return {
        renderComponent: ({ setting: { viewBy, year, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendLiquidityCorp isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearLiquidityCorp isDynamicReport year={year} />
          ) : (
            <TableLiquidityCorp isDynamicReport checkTable={checkTable} />
          ),
        isFixSvg: viewBy === VIEW_BY.EACH_YEAR,
        thunk: [
          ({ companyInfo, settingFs }) =>
            getCorpLiquidityThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreCorpLiquidity())
        },
        isWaitForMount: [VIEW_BY.TREND, VIEW_BY.TABLE].includes(viewBy),
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0020', ...detailItemCheck },
            { value: 'RT0019', ...detailItemCheck },
            { value: 'RT0018', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'RT0020', ...detailItemCheckRequire },
                { value: 'RTI0020', ...detailItemCheckRequire },
                { value: 'RT0019', ...detailItemCheckRequire },
                { value: 'RTI0019', ...detailItemCheckRequire },
                { value: 'RT0018', ...detailItemCheckRequire },
                { value: 'RTI0018', ...detailItemCheckRequire },
                { value: 'RT0001', ...detailItemCheckRequire },
                { value: 'RT0040', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0020', ...detailItemCheckTable },
            { value: 'RTI0020', ...detailItemCheckTable },
            { value: 'RT0019', ...detailItemCheckTable },
            { value: 'RTI0019', ...detailItemCheckTable },
            { value: 'RT0018', ...detailItemCheckTable },
            { value: 'RTI0018', ...detailItemCheckTable },
            { value: 'RT0001', ...detailItemCheckTable },
            { value: 'RT0040', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Liquidity',
        },
      }
    case PANELS.SOLVENCY_CORP:
      return {
        renderComponent: ({ setting: { viewBy, year, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendSolvencyCorp isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearSolvencyCorp isDynamicReport year={year} />
          ) : (
            <TableSolvencyCorp isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getCorpSolvencyThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreCorpSolvency())
        },
        isWaitForMount: [VIEW_BY.TREND, VIEW_BY.TABLE].includes(viewBy),
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0027', ...detailItemCheck },
            { value: 'RTI0027', ...detailItemCheck },
            { value: 'RT0034', ...detailItemCheck },
            { value: 'RTI0034', ...detailItemCheck },
            { value: 'RT0037', ...detailItemCheck },
            { value: 'RTI0037', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'RT0027', ...detailItemCheckRequire },
                { value: 'RT0034', ...detailItemCheckRequire },
                { value: 'RT0037', ...detailItemCheckRequire },
                { value: 'FA002', ...detailItemCheckRequire },
                { value: 'FA160', ...detailItemCheckRequire },
                { value: 'FA159', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0027', ...detailItemCheckTable },
            { value: 'RTI0027', ...detailItemCheckTable },
            { value: 'RT0034', ...detailItemCheckTable },
            { value: 'RTI0034', ...detailItemCheckTable },
            { value: 'RT0037', ...detailItemCheckTable },
            { value: 'RTI0037', ...detailItemCheckTable },
            { value: 'FA002', ...detailItemCheckTable },
            { value: 'FA160', ...detailItemCheckTable },
            { value: 'FA159', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Solvency',
        },
      }
    case PANELS.COVERAGE_CORP:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendCoverageCorp isDynamicReport check={check} />
          ) : (
            <TableCoverageCorp isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getCorpCoverageThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreCorpCoverage())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0044', ...detailItemCheck },
            { value: 'RT0045', ...detailItemCheck },
            { value: 'RT0046', ...detailItemCheck },
            { value: 'RT0047', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0044', ...detailItemCheckTable },
            { value: 'RT0045', ...detailItemCheckTable },
            { value: 'RT0046', ...detailItemCheckTable },
            { value: 'RT0047', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Coverage',
        },
      }
    case PANELS.EARNINGS_BREAKDOWN_CORP:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendEarningBreakdownCorp isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearEarningBreakdownCorp isDynamicReport year={year} />
          ) : (
            <TableEarningBreakdownCorp
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getCorpEarningBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreCorpEarningBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'FA165', ...detailItemCheck },
            { value: 'FA164', ...detailItemCheck },
            { value: 'FA029', ...detailItemCheck },
            { value: 'FA189', ...detailItemCheck },
            { value: 'FA168', ...detailItemCheck },
            { value: 'FA162', ...detailItemCheck },
            { value: 'FA167', ...detailItemCheck },
            { value: 'FA166', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'FA165', ...detailItemCheckRequire },
                { value: 'FA164', ...detailItemCheckRequire },
                { value: 'FA029', ...detailItemCheckRequire },
                { value: 'FA189', ...detailItemCheckRequire },
                { value: 'FA168', ...detailItemCheckRequire },
                { value: 'FA161', ...detailItemCheckRequire },
                { value: 'FA166', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'FA165', ...detailItemCheckTable },
            { value: 'FA164', ...detailItemCheckTable },
            { value: 'FA029', ...detailItemCheckTable },
            { value: 'FA189', ...detailItemCheckTable },
            { value: 'FA168', ...detailItemCheckTable },
            { value: 'FA162', ...detailItemCheckTable },
            { value: 'FA167', ...detailItemCheckTable },
            { value: 'FA161', ...detailItemCheckTable },
            { value: 'FA166', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'EarningsBreakdown',
        },
      }
    case PANELS.BALANCE_SHEET_BREAKDOWN_CORP:
      return {
        renderComponent: ({
          setting: {
            viewBy,
            check,
            chartEachYear,
            year,
            checkTable1,
            checkTable2,
            checkTable3,
            tabTable,
          },
        }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendBalanceBreakdownCorp isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearBalanceBreakdownCorp
              isDynamicReport
              year={year}
              chart={chartEachYear}
            />
          ) : (
            <TableBalanceBreakdownCorp
              isDynamicReport
              checkTable={[...checkTable1, ...checkTable2, ...checkTable3]}
              tabTable={tabTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getCorpBalanceBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreCorpBalanceBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.ASSET_STRUCTURE"
                  children={[
                    'BS2',
                    'FA004',
                    'BS18',
                    'FA005',
                    'FA006',
                    'RT0172',
                  ]}
                />
              ),
              children: [
                { value: 'BS2', ...detailItemCheck },
                { value: 'FA004', ...detailItemCheck },
                { value: 'BS18', ...detailItemCheck },
                { value: 'FA005', ...detailItemCheck },
                { value: 'FA006', ...detailItemCheck },
                { value: 'RT0172', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.LIABILITIES_STRUCTURE"
                  children={[
                    'FA013',
                    'FA016',
                    'FA015',
                    'FA014',
                    'FA017',
                    'FA018',
                  ]}
                />
              ),
              children: [
                { value: 'FA013', ...detailItemCheck },
                { value: 'FA016', ...detailItemCheck },
                { value: 'FA015', ...detailItemCheck },
                { value: 'FA014', ...detailItemCheck },
                { value: 'FA017', ...detailItemCheck },
                { value: 'FA018', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.EQUITY_STRUCTURE"
                  children={['FA024', 'BS109', 'FA025', 'RT0173']}
                />
              ),
              children: [
                { value: 'FA024', ...detailItemCheck },
                { value: 'BS109', ...detailItemCheck },
                { value: 'FA025', ...detailItemCheck },
                { value: 'RT0173', ...detailItemCheck },
              ],
            },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 1,
                  title: 'financialAnalysis.ASSET_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA152', ...detailItemCheckRequire },
                    { value: 'FA007', ...detailItemCheckRequire },
                    { value: 'FA008', ...detailItemCheckRequire },
                    { value: 'FA009', ...detailItemCheckRequire },
                    { value: 'FA010', ...detailItemCheckRequire },
                    { value: 'FA011', ...detailItemCheckRequire },
                    { value: 'FA012', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 2,
                  title: 'financialAnalysis.LIABILITIES_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA159', ...detailItemCheckRequire },
                    { value: 'FA019', ...detailItemCheckRequire },
                    { value: 'FA020', ...detailItemCheckRequire },
                    { value: 'FA021', ...detailItemCheckRequire },
                    { value: 'FA022', ...detailItemCheckRequire },
                    { value: 'FA023', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 3,
                  title: 'financialAnalysis.EQUITY_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA160', ...detailItemCheckRequire },
                    { value: 'FA026', ...detailItemCheckRequire },
                    { value: 'FA027', ...detailItemCheckRequire },
                    { value: 'FA023', ...detailItemCheckRequire },
                  ],
                },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 0,
              title: 'financialAnalysis.ASSET_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS2', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA003', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA004', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS18', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA005', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA006', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS64', ...detailItemCheckTable, key: 'checkTable1' },
                {
                  value: 'RT0172',
                  ...detailItemCheckTable,
                  key: 'checkTable1',
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 1,
              title: 'financialAnalysis.LIABILITIES_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'FA013', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA014', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA015', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA016', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA017', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS65', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA018', ...detailItemCheckTable, key: 'checkTable2' },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 2,
              title: 'financialAnalysis.EQUITY_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'FA024', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS109', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'FA025', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS95', ...detailItemCheckTable, key: 'checkTable3' },
                {
                  value: 'RT0173',
                  ...detailItemCheckTable,
                  key: 'checkTable3',
                },
              ],
            },
          ],
          ratioGroupCode: 'BalanceSheetBreakdown',
        },
      }
    case PANELS.CASH_FLOW_STRUCTURE_CORP:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendCashBreakdownCorp isDynamicReport check={check} />
          ) : (
            <TableCashBreakdownCorp isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getCorpCashBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreCorpCashBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'CF19', ...detailItemCheck },
            { value: 'CF30', ...detailItemCheck },
            { value: 'CF37', ...detailItemCheck },
            { value: 'CF38', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'CF19', ...detailItemCheckTable },
            { value: 'CF30', ...detailItemCheckTable },
            { value: 'CF37', ...detailItemCheckTable },
            { value: 'CF38', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'CashFlowBreakdown',
        },
      }
    // bank
    case PANELS.QUICK_ASSESSMENT_BANK:
      return {
        renderComponent: () => <QuickAssessmentBank isDynamicReport />,
        width: 900,
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankQuickAssessmentThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankQuickAssessment())
        },
      }
    case PANELS.LOAN_BOOK_BREAKDOWN_AND_COVERAGE_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendLoanBookBreakdownBank
              isDynamicReport
              check={check}
              year={year}
            />
          ) : (
            <TableLoanBookBreakdownBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankLoanBookBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankLoanBookBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.LOAN_PORTFOLIO_BY_QUALITY"
                  children={[
                    'NB66',
                    'NB67',
                    'NB68',
                    'NB69',
                    'NB70',
                    'FA146',
                    'FA147',
                  ]}
                />
              ),
              children: [
                { value: 'NB66', ...detailItemCheck },
                { value: 'NB67', ...detailItemCheck },
                { value: 'NB68', ...detailItemCheck },
                { value: 'NB69', ...detailItemCheck },
                { value: 'NB70', ...detailItemCheck },
                { value: 'FA146', ...detailItemCheck },
                { value: 'FA147', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.LOAN_PORTFOLIO_BY_TERM"
                  children={['NB72', 'NB73', 'NB74']}
                />
              ),
              children: [
                { value: 'NB72', ...detailItemCheck },
                { value: 'NB73', ...detailItemCheck },
                { value: 'NB74', ...detailItemCheck },
              ],
            },
            {
              value: 'top3Sector',
              ...detailItemCheck,
              title: 'financialAnalysis.TOP_3_SECTOR_IN_LOAN_PORTFOLIO',
              isDisableMapTitle: true,
            },
            {
              value: 'lossToNpl',
              ...detailItemCheck,
              title: 'financialAnalysis.LOAN_LOSS_TO_NPL',
              isDisableMapTitle: true,
            },
            {
              value: 'lossToTotalLoan',
              ...detailItemCheck,
              title: 'financialAnalysis.LOAN_LOSS_TO_TOTAL_LOAN',
              isDisableMapTitle: true,
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'NB66', ...detailItemCheckTable },
            { value: 'NB67', ...detailItemCheckTable },
            { value: 'NB68', ...detailItemCheckTable },
            { value: 'NB69', ...detailItemCheckTable },
            { value: 'NB70', ...detailItemCheckTable },
            { value: 'FA146', ...detailItemCheckTable },
            { value: 'FA147', ...detailItemCheckTable },
            { value: 'NB72', ...detailItemCheckTable },
            { value: 'NB73', ...detailItemCheckTable },
            { value: 'NB74', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'LoanBookBreakdownAndCoverage',
        },
      }
    case PANELS.DEPOSIT_AND_CREDIT_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendDepositAndCreditBank isDynamicReport check={check} />
          ) : (
            <TableDepositAndCreditBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankDepositAndCreditThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankDepositAndCredit())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'BS178', ...detailItemCheck },
            { value: 'BS158', ...detailItemCheck },
            { value: 'RT0297', ...detailItemCheck },
            { value: 'RT0296', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'BS178', ...detailItemCheckTable },
            { value: 'BS158', ...detailItemCheckTable },
            { value: 'RT0297', ...detailItemCheckTable },
            { value: 'RT0296', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'DepositAndCredit',
        },
      }
    case PANELS.AVERAGE_COST_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendAverageCostBank isDynamicReport check={check} />
          ) : (
            <TableAverageCostBank isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankAverageCostThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankAverageCost())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'FA149', ...detailItemCheck },
            { value: 'RT0239', ...detailItemCheck },
            { value: 'FA061', ...detailItemCheck },
            { value: 'FA169', ...detailItemCheckRequire },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'FA149', ...detailItemCheckTable },
            { value: 'RT0239', ...detailItemCheckTable },
            { value: 'FA061', ...detailItemCheckTable },
            { value: 'FA169', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'AverageCostOfFinancingAndCreditCost',
        },
      }
    case PANELS.EARNINGS_QUALITY_BANK:
      return {
        renderComponent: ({ setting: { viewBy, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendEarningQualityBank isDynamicReport check={check} />
          ) : (
            <TableEarningQualityBank isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankEarningsQualityThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankEarningQuality())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'FA150', ...detailItemCheck },
            { value: 'RT0252', ...detailItemCheck },
            { value: 'RT0060', ...detailItemCheck },
            { value: 'RT0059', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'FA150', ...detailItemCheckTable },
            { value: 'RT0252', ...detailItemCheckTable },
            { value: 'RT0060', ...detailItemCheckTable },
            { value: 'RT0059', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'EarningsQuality',
        },
      }
    case PANELS.CAPITAL_AND_LEVERAGE_BANK:
      return {
        renderComponent: ({ setting: { viewBy, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendCapitalAndLeverageBank isDynamicReport check={check} />
          ) : (
            <TableCapitalAndLeverageBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankCapitalAndLeverageThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankCapitalAndLeverage())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0248', ...detailItemCheck },
            { value: 'NB219', ...detailItemCheck },
            { value: 'FA060', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0248', ...detailItemCheckTable },
            { value: 'NB219', ...detailItemCheckTable },
            { value: 'FA060', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'CapitalAndLeverage',
        },
      }
    case PANELS.LIQUIDITY_BANK:
      return {
        renderComponent: ({ setting: { viewBy, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendLiquidityBank isDynamicReport check={check} />
          ) : (
            <TableLiquidityBank isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankLiquidityThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankLiquidity())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0277', ...detailItemCheck },
            { value: 'FA111', ...detailItemCheck },
            { value: 'RT0318', ...detailItemCheck },
            { value: 'FA149', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0277', ...detailItemCheckTable },
            { value: 'FA111', ...detailItemCheckTable },
            { value: 'RT0318', ...detailItemCheckTable },
            { value: 'FA149', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Liquidity',
        },
      }
    case PANELS.FUNDING_STRUCTURE_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendFundingStructureBank isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearFundingStructureBank isDynamicReport year={year} />
          ) : (
            <TableFundingStructureBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankFundingStructureThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankFundingStructure())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'BS178', ...detailItemCheck },
            { value: 'BS174', ...detailItemCheck },
            { value: 'BS175', ...detailItemCheck },
            { value: 'BS180', ...detailItemCheck },
            { value: 'BS181', ...detailItemCheck },
            { value: 'FA031', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'FA032', ...detailItemCheckRequire },
                { value: 'FA033', ...detailItemCheckRequire },
                { value: 'FA034', ...detailItemCheckRequire },
                { value: 'FA035', ...detailItemCheckRequire },
                { value: 'FA036', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'BS178', ...detailItemCheckTable },
            { value: 'BS174', ...detailItemCheckTable },
            { value: 'BS175', ...detailItemCheckTable },
            { value: 'BS180', ...detailItemCheckTable },
            { value: 'BS181', ...detailItemCheckTable },
            { value: 'FA156', ...detailItemCheckTable },
            { value: 'FA031', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Funding',
        },
      }
    case PANELS.BALANCE_SHEET_BREAKDOWN_BANK:
      return {
        renderComponent: ({
          setting: {
            viewBy,
            check,
            year,
            chartEachYear,
            tabTable,
            checkTable1,
            checkTable2,
            checkTable3,
          },
        }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendBalanceBreakdownBank isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearBalanceBreakdownBank
              isDynamicReport
              year={year}
              chart={chartEachYear}
            />
          ) : (
            <TableBalanceBreakdownBank
              isDynamicReport
              checkTable={[...checkTable1, ...checkTable2, ...checkTable3]}
              tabTable={tabTable}
            />
          ),
        width: 850,
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankBalanceBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankBalanceBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.ASSET_STRUCTURE"
                  children={[
                    'BS2',
                    'FA037',
                    'FA038',
                    'BS158',
                    'FA039',
                    'FA040',
                    'RT0296',
                    'RT0172',
                  ]}
                />
              ),
              children: [
                { value: 'BS2', ...detailItemCheck },
                { value: 'FA037', ...detailItemCheck },
                { value: 'FA038', ...detailItemCheck },
                { value: 'BS158', ...detailItemCheck },
                { value: 'FA039', ...detailItemCheck },
                { value: 'FA040', ...detailItemCheck },
                { value: 'RT0296', ...detailItemCheck },
                { value: 'RT0172', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.LIABILITIES_STRUCTURE"
                  children={[
                    'BS174',
                    'BS175',
                    'BS178',
                    'BS181',
                    'FA047',
                    'FA048',
                  ]}
                />
              ),
              children: [
                { value: 'BS174', ...detailItemCheck },
                { value: 'BS175', ...detailItemCheck },
                { value: 'BS178', ...detailItemCheck },
                { value: 'BS181', ...detailItemCheck },
                { value: 'FA047', ...detailItemCheck },
                { value: 'FA048', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.EQUITY_STRUCTURE"
                  children={['BS186', 'BS187', 'BS109', 'FA054', 'RT0173']}
                />
              ),
              children: [
                { value: 'BS186', ...detailItemCheck },
                { value: 'BS187', ...detailItemCheck },
                { value: 'BS109', ...detailItemCheck },
                { value: 'FA054', ...detailItemCheck },
                { value: 'RT0173', ...detailItemCheck },
              ],
            },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 1,
                  title: 'financialAnalysis.ASSET_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA153', ...detailItemCheckRequire },
                    { value: 'FA041', ...detailItemCheckRequire },
                    { value: 'FA042', ...detailItemCheckRequire },
                    { value: 'FA043', ...detailItemCheckRequire },
                    { value: 'FA044', ...detailItemCheckRequire },
                    { value: 'FA045', ...detailItemCheckRequire },
                    { value: 'FA046', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 2,
                  title: 'financialAnalysis.LIABILITIES_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA159', ...detailItemCheckRequire },
                    { value: 'FA049', ...detailItemCheckRequire },
                    { value: 'FA050', ...detailItemCheckRequire },
                    { value: 'FA051', ...detailItemCheckRequire },
                    { value: 'FA052', ...detailItemCheckRequire },
                    { value: 'FA053', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 3,
                  title: 'financialAnalysis.EQUITY_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA160', ...detailItemCheckRequire },
                    { value: 'FA055', ...detailItemCheckRequire },
                    { value: 'FA056', ...detailItemCheckRequire },
                    { value: 'FA057', ...detailItemCheckRequire },
                    { value: 'FA058', ...detailItemCheckRequire },
                  ],
                },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 0,
              title: 'financialAnalysis.ASSET_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS2', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA037', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA038', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS158', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA039', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA040', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS64', ...detailItemCheckTable, key: 'checkTable1' },
                {
                  value: 'RT0296',
                  ...detailItemCheckTable,
                  key: 'checkTable1',
                },
                {
                  value: 'RT0172',
                  ...detailItemCheckTable,
                  key: 'checkTable1',
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 1,
              title: 'financialAnalysis.LIABILITIES_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS174', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS175', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS178', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS181', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA047', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS65', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA048', ...detailItemCheckTable, key: 'checkTable2' },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 2,
              title: 'financialAnalysis.EQUITY_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS186', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS187', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS109', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'FA054', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS95', ...detailItemCheckTable, key: 'checkTable3' },
                {
                  value: 'RT0173',
                  ...detailItemCheckTable,
                  key: 'checkTable3',
                },
              ],
            },
          ],
          ratioGroupCode: 'BalanceSheetBreakdown',
        },
      }
    case PANELS.EARNINGS_BREAKDOWN_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendEarningBreakdownBank isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearEarningBreakdownBank isDynamicReport year={year} />
          ) : (
            <TableEarningBreakdownBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankEarningBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankEarningBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'IS27', ...detailItemCheck },
            { value: 'IS30', ...detailItemCheck },
            { value: 'FA059', ...detailItemCheck },
            { value: 'IS39', ...detailItemCheck },
            { value: 'IS41', ...detailItemCheck },
            { value: 'IS16', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'IS27', ...detailItemCheckRequire },
                { value: 'IS30', ...detailItemCheckRequire },
                { value: 'FA059', ...detailItemCheckRequire },
                { value: 'IS39', ...detailItemCheckRequire },
                { value: 'IS41', ...detailItemCheckRequire },
                { value: 'IS16', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'IS27', ...detailItemCheckTable },
            { value: 'IS30', ...detailItemCheckTable },
            { value: 'FA059', ...detailItemCheckTable },
            { value: 'IS39', ...detailItemCheckTable },
            { value: 'IS41', ...detailItemCheckTable },
            { value: 'IS16', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'EarningsBreakdown',
        },
      }
    case PANELS.CASH_FLOW_STRUCTURE_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendCashBreakdownBank isDynamicReport check={check} />
          ) : (
            <TableCashBreakdownBank isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getBankCashBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreBankCashBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'CF19', ...detailItemCheck },
            { value: 'CF30', ...detailItemCheck },
            { value: 'CF37', ...detailItemCheck },
            { value: 'CF38', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'CF19', ...detailItemCheckTable },
            { value: 'CF30', ...detailItemCheckTable },
            { value: 'CF37', ...detailItemCheckTable },
            { value: 'CF38', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'CashFlowBreakdown',
        },
      }
    // non bank
    case PANELS.QUICK_ASSESSMENT_NON_BANK:
      return {
        renderComponent: () => <QuickAssessmentNonBank isDynamicReport />,
        width: 900,
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankQuickAssessmentThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankQuickAssessment())
        },
      }
    case PANELS.LOAN_BOOK_BREAKDOWN_AND_COVERAGE_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendLoanBookBreakdownNonBank
              isDynamicReport
              check={check}
              year={year}
            />
          ) : (
            <TableLoanBookBreakdownNonBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankLoanBookBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankLoanBookBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.LOAN_PORTFOLIO_BY_QUALITY"
                  children={[
                    'NB66',
                    'NB67',
                    'NB68',
                    'NB69',
                    'NB70',
                    'FA146',
                    'FA147',
                  ]}
                />
              ),
              children: [
                { value: 'NB66', ...detailItemCheck },
                { value: 'NB67', ...detailItemCheck },
                { value: 'NB68', ...detailItemCheck },
                { value: 'NB69', ...detailItemCheck },
                { value: 'NB70', ...detailItemCheck },
                { value: 'FA146', ...detailItemCheck },
                { value: 'FA147', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.LOAN_PORTFOLIO_BY_TERM"
                  children={['NB72', 'NB73', 'NB74']}
                />
              ),
              children: [
                { value: 'NB72', ...detailItemCheck },
                { value: 'NB73', ...detailItemCheck },
                { value: 'NB74', ...detailItemCheck },
              ],
            },
            {
              value: 'top3Sector',
              ...detailItemCheck,
              title: 'financialAnalysis.TOP_3_SECTOR_IN_LOAN_PORTFOLIO',
              isDisableMapTitle: true,
            },
            {
              value: 'lossToNpl',
              ...detailItemCheck,
              title: 'financialAnalysis.LOAN_LOSS_TO_NPL',
              isDisableMapTitle: true,
            },
            {
              value: 'lossToTotalLoan',
              ...detailItemCheck,
              title: 'financialAnalysis.LOAN_LOSS_TO_TOTAL_LOAN',
              isDisableMapTitle: true,
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'NB66', ...detailItemCheckTable },
            { value: 'NB67', ...detailItemCheckTable },
            { value: 'NB68', ...detailItemCheckTable },
            { value: 'NB69', ...detailItemCheckTable },
            { value: 'NB70', ...detailItemCheckTable },
            { value: 'FA146', ...detailItemCheckTable },
            { value: 'FA147', ...detailItemCheckTable },
            { value: 'NB72', ...detailItemCheckTable },
            { value: 'NB73', ...detailItemCheckTable },
            { value: 'NB74', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'LoanBookBreakdownAndCoverage',
        },
      }
    case PANELS.DEPOSIT_AND_CREDIT_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendDepositAndCreditNonBank isDynamicReport check={check} />
          ) : (
            <TableDepositAndCreditNonBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankDepositAndCreditThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankDepositAndCredit())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'BS178', ...detailItemCheck },
            { value: 'BS158', ...detailItemCheck },
            { value: 'RT0297', ...detailItemCheck },
            { value: 'RT0296', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'BS178', ...detailItemCheckTable },
            { value: 'BS158', ...detailItemCheckTable },
            { value: 'RT0297', ...detailItemCheckTable },
            { value: 'RT0296', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'DepositAndCredit',
        },
      }
    case PANELS.AVERAGE_COST_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendAverageCostNonBank isDynamicReport check={check} />
          ) : (
            <TableAverageCostNonBank isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankAverageCostThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankAverageCost())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'FA149', ...detailItemCheck },
            { value: 'RT0239', ...detailItemCheck },
            { value: 'FA061', ...detailItemCheck },
            { value: 'FA169', ...detailItemCheckRequire },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'FA149', ...detailItemCheckTable },
            { value: 'RT0239', ...detailItemCheckTable },
            { value: 'FA061', ...detailItemCheckTable },
            { value: 'FA169', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'AverageCostOfFinancingAndCreditCost',
        },
      }
    case PANELS.EARNINGS_QUALITY_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendEarningQualityNonBank isDynamicReport check={check} />
          ) : (
            <TableEarningQualityNonBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankEarningsQualityThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankEarningQuality())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'FA150', ...detailItemCheck },
            { value: 'RT0252', ...detailItemCheck },
            { value: 'RT0060', ...detailItemCheck },
            { value: 'RT0059', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'FA150', ...detailItemCheckTable },
            { value: 'RT0252', ...detailItemCheckTable },
            { value: 'RT0060', ...detailItemCheckTable },
            { value: 'RT0059', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'EarningsQuality',
        },
      }
    case PANELS.CAPITAL_AND_LEVERAGE_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendCapitalAndLeverageNonBank isDynamicReport check={check} />
          ) : (
            <TableCapitalAndLeverageNonBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankCapitalAndLeverageThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankCapitalAndLeverage())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0248', ...detailItemCheck },
            { value: 'NB219', ...detailItemCheck },
            { value: 'FA060', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0248', ...detailItemCheckTable },
            { value: 'NB219', ...detailItemCheckTable },
            { value: 'FA060', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'CapitalAndLeverage',
        },
      }
    case PANELS.LIQUIDITY_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendLiquidityNonBank isDynamicReport check={check} />
          ) : (
            <TableLiquidityNonBank isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankLiquidityThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankLiquidity())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0277', ...detailItemCheck },
            { value: 'FA111', ...detailItemCheck },
            { value: 'RT0318', ...detailItemCheck },
            { value: 'FA149', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0277', ...detailItemCheckTable },
            { value: 'FA111', ...detailItemCheckTable },
            { value: 'RT0318', ...detailItemCheckTable },
            { value: 'FA149', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Liquidity',
        },
      }
    case PANELS.FUNDING_STRUCTURE_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendFundingStructureNonBank isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearFundingStructureNonBank isDynamicReport year={year} />
          ) : (
            <TableFundingStructureNonBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankFundingStructureThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankFundingStructure())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'BS178', ...detailItemCheck },
            { value: 'BS174', ...detailItemCheck },
            { value: 'BS175', ...detailItemCheck },
            { value: 'BS180', ...detailItemCheck },
            { value: 'BS181', ...detailItemCheck },
            { value: 'FA031', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'FA032', ...detailItemCheckRequire },
                { value: 'FA033', ...detailItemCheckRequire },
                { value: 'FA034', ...detailItemCheckRequire },
                { value: 'FA035', ...detailItemCheckRequire },
                { value: 'FA036', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'BS178', ...detailItemCheckTable },
            { value: 'BS174', ...detailItemCheckTable },
            { value: 'BS175', ...detailItemCheckTable },
            { value: 'BS180', ...detailItemCheckTable },
            { value: 'BS181', ...detailItemCheckTable },
            { value: 'FA156', ...detailItemCheckTable },
            { value: 'FA031', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Funding',
        },
      }
    case PANELS.BALANCE_SHEET_BREAKDOWN_NON_BANK:
      return {
        renderComponent: ({
          setting: {
            viewBy,
            check,
            year,
            chartEachYear,
            tabTable,
            checkTable1,
            checkTable2,
            checkTable3,
          },
        }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendBalanceBreakdownNonBank isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearBalanceBreakdownNonBank
              isDynamicReport
              year={year}
              chart={chartEachYear}
            />
          ) : (
            <TableBalanceBreakdownNonBank
              isDynamicReport
              checkTable={[...checkTable1, ...checkTable2, ...checkTable3]}
              tabTable={tabTable}
            />
          ),
        width: 850,
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankBalanceBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankBalanceBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.ASSET_STRUCTURE"
                  children={[
                    'BS2',
                    'FA037',
                    'FA038',
                    'BS158',
                    'FA039',
                    'FA040',
                    'RT0296',
                    'RT0172',
                  ]}
                />
              ),
              children: [
                { value: 'BS2', ...detailItemCheck },
                { value: 'FA037', ...detailItemCheck },
                { value: 'FA038', ...detailItemCheck },
                { value: 'BS158', ...detailItemCheck },
                { value: 'FA039', ...detailItemCheck },
                { value: 'FA040', ...detailItemCheck },
                { value: 'RT0296', ...detailItemCheck },
                { value: 'RT0172', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.LIABILITIES_STRUCTURE"
                  children={[
                    'BS174',
                    'BS175',
                    'BS178',
                    'BS181',
                    'FA047',
                    'FA048',
                  ]}
                />
              ),
              children: [
                { value: 'BS174', ...detailItemCheck },
                { value: 'BS175', ...detailItemCheck },
                { value: 'BS178', ...detailItemCheck },
                { value: 'BS181', ...detailItemCheck },
                { value: 'FA047', ...detailItemCheck },
                { value: 'FA048', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.EQUITY_STRUCTURE"
                  children={['BS186', 'BS187', 'BS109', 'FA054', 'RT0173']}
                />
              ),
              children: [
                { value: 'BS186', ...detailItemCheck },
                { value: 'BS187', ...detailItemCheck },
                { value: 'BS109', ...detailItemCheck },
                { value: 'FA054', ...detailItemCheck },
                { value: 'RT0173', ...detailItemCheck },
              ],
            },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 1,
                  title: 'financialAnalysis.ASSET_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA153', ...detailItemCheckRequire },
                    { value: 'FA041', ...detailItemCheckRequire },
                    { value: 'FA042', ...detailItemCheckRequire },
                    { value: 'FA043', ...detailItemCheckRequire },
                    { value: 'FA044', ...detailItemCheckRequire },
                    { value: 'FA045', ...detailItemCheckRequire },
                    { value: 'FA046', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 2,
                  title: 'financialAnalysis.LIABILITIES_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA159', ...detailItemCheckRequire },
                    { value: 'FA049', ...detailItemCheckRequire },
                    { value: 'FA050', ...detailItemCheckRequire },
                    { value: 'FA051', ...detailItemCheckRequire },
                    { value: 'FA052', ...detailItemCheckRequire },
                    { value: 'FA053', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 3,
                  title: 'financialAnalysis.EQUITY_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA160', ...detailItemCheckRequire },
                    { value: 'FA055', ...detailItemCheckRequire },
                    { value: 'FA056', ...detailItemCheckRequire },
                    { value: 'FA057', ...detailItemCheckRequire },
                    { value: 'FA058', ...detailItemCheckRequire },
                  ],
                },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 0,
              title: 'financialAnalysis.ASSET_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS2', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA037', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA038', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS158', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA039', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA040', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS64', ...detailItemCheckTable, key: 'checkTable1' },
                {
                  value: 'RT0296',
                  ...detailItemCheckTable,
                  key: 'checkTable1',
                },
                {
                  value: 'RT0172',
                  ...detailItemCheckTable,
                  key: 'checkTable1',
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 1,
              title: 'financialAnalysis.LIABILITIES_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS174', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS175', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS178', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS181', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA047', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS65', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA048', ...detailItemCheckTable, key: 'checkTable2' },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 2,
              title: 'financialAnalysis.EQUITY_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS186', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS187', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS109', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'FA054', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS95', ...detailItemCheckTable, key: 'checkTable3' },
                {
                  value: 'RT0173',
                  ...detailItemCheckTable,
                  key: 'checkTable3',
                },
              ],
            },
          ],
          ratioGroupCode: 'BalanceSheetBreakdown',
        },
      }
    case PANELS.EARNINGS_BREAKDOWN_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendEarningBreakdownNonBank isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearEarningBreakdownNonBank isDynamicReport year={year} />
          ) : (
            <TableEarningBreakdownNonBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankEarningBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankEarningBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'IS27', ...detailItemCheck },
            { value: 'IS30', ...detailItemCheck },
            { value: 'FA059', ...detailItemCheck },
            { value: 'IS39', ...detailItemCheck },
            { value: 'IS41', ...detailItemCheck },
            { value: 'IS16', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'IS27', ...detailItemCheckRequire },
                { value: 'IS30', ...detailItemCheckRequire },
                { value: 'FA059', ...detailItemCheckRequire },
                { value: 'IS39', ...detailItemCheckRequire },
                { value: 'IS41', ...detailItemCheckRequire },
                { value: 'IS16', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'IS27', ...detailItemCheckTable },
            { value: 'IS30', ...detailItemCheckTable },
            { value: 'FA059', ...detailItemCheckTable },
            { value: 'IS39', ...detailItemCheckTable },
            { value: 'IS41', ...detailItemCheckTable },
            { value: 'IS16', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'EarningsBreakdown',
        },
      }
    case PANELS.CASH_FLOW_STRUCTURE_NON_BANK:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendCashBreakdownNonBank isDynamicReport check={check} />
          ) : (
            <TableCashBreakdownNonBank
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getNonBankCashBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreNonBankCashBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'CF19', ...detailItemCheck },
            { value: 'CF30', ...detailItemCheck },
            { value: 'CF37', ...detailItemCheck },
            { value: 'CF38', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'CF19', ...detailItemCheckTable },
            { value: 'CF30', ...detailItemCheckTable },
            { value: 'CF37', ...detailItemCheckTable },
            { value: 'CF38', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'CashFlowBreakdown',
        },
      }
    // security
    case PANELS.OPERATING_SALES_SECU:
      return {
        renderComponent: ({
          setting: {
            viewBy,
            check,
            year,
            chartEachYear,
            tabTable,
            checkTable1,
            checkTable2,
          },
        }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendOperatingIncomeSecu isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearOperatingIncomeSecu
              isDynamicReport
              year={year}
              chart={chartEachYear}
            />
          ) : (
            <TableOperatingIncomeSecu
              isDynamicReport
              checkTable={[...checkTable1, ...checkTable2]}
              tab={tabTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuOperatingIncomeThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuOperatingIncome())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.OPERATING_INCOME_BREAKDOWN"
                  children={['FA062', 'IS111', 'IS114', 'FA063', 'FA064']}
                />
              ),
              children: [
                { value: 'FA062', ...detailItemCheck },
                { value: 'IS111', ...detailItemCheck },
                { value: 'IS114', ...detailItemCheck },
                { value: 'FA063', ...detailItemCheck },
                { value: 'FA064', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.GAIN_PROPRIETARY_TRADING_BREAKDOWN"
                  children={['IS106', 'IS110', 'IS112']}
                />
              ),
              children: [
                { value: 'IS106', ...detailItemCheck },
                { value: 'IS110', ...detailItemCheck },
                { value: 'IS112', ...detailItemCheck },
              ],
            },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 1,
                  title: 'financialAnalysis.OPERATING_INCOME_BREAKDOWN',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA155', ...detailItemCheckRequire },
                    { value: 'FA065', ...detailItemCheckRequire },
                    { value: 'FA066', ...detailItemCheckRequire },
                    { value: 'FA067', ...detailItemCheckRequire },
                    { value: 'FA068', ...detailItemCheckRequire },
                    { value: 'FA069', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 2,
                  title: 'financialAnalysis.GAIN_PROPRIETARY_TRADING_BREAKDOWN',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA070', ...detailItemCheckRequire },
                    { value: 'FA071', ...detailItemCheckRequire },
                    { value: 'FA072', ...detailItemCheckRequire },
                  ],
                },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 0,
              title: 'financialAnalysis.OPERATING_INCOME_BREAKDOWN',
              isDisableMapTitle: true,
              children: [
                { value: 'FA062', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'IS111', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'IS114', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA063', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA064', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'IS3', ...detailItemCheckTable, key: 'checkTable1' },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 1,
              title: 'financialAnalysis.GAIN_PROPRIETARY_TRADING_BREAKDOWN',
              isDisableMapTitle: true,
              children: [
                { value: 'IS106', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'IS110', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'IS112', ...detailItemCheckTable, key: 'checkTable2' },
              ],
            },
          ],
          ratioGroupCode: 'OperatingIncome',
        },
      }
    case PANELS.BUSINESS_POSITION_SECU:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendBusinessPositionSecu isDynamicReport check={check} />
          ) : (
            <TableBusinessPositionSecu
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuBusinessPositionThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuBusinessPosition())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'IS3', ...detailItemCheck },
            { value: 'BS64', ...detailItemCheck },
            { value: 'FA073', ...detailItemCheck },
            { value: 'FA074', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'IS3', ...detailItemCheckTable },
            { value: 'BS64', ...detailItemCheckTable },
            { value: 'FA073', ...detailItemCheckTable },
            { value: 'FA074', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'BusinessPosition',
        },
      }
    case PANELS.FINANCIAL_ASSETS_SECU:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendFinancialAssetSecu isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearFinancialAssetSecu isDynamicReport year={year} />
          ) : (
            <TableFinancialAssetSecu isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuFinancialAssetsThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuFinancialAssets())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'BS249', ...detailItemCheck },
            { value: 'FA075', ...detailItemCheck },
            { value: 'FA076', ...detailItemCheck },
            { value: 'FA077', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'FA078', ...detailItemCheckRequire },
                { value: 'FA079', ...detailItemCheckRequire },
                { value: 'FA080', ...detailItemCheckRequire },
                { value: 'FA081', ...detailItemCheckRequire },
                { value: 'FA112', ...detailItemCheckRequire },
                { value: 'FA113', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'BS249', ...detailItemCheckTable },
            { value: 'FA075', ...detailItemCheckTable },
            { value: 'FA076', ...detailItemCheckTable },
            { value: 'FA077', ...detailItemCheckTable },
            { value: 'FA158', ...detailItemCheckTable },
            { value: 'FA112', ...detailItemCheckTable },
            { value: 'FA113', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'FinancialAssets',
        },
      }
    case PANELS.EARNING_QUALITY_SECU:
      return {
        renderComponent: ({ setting: { viewBy, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendEarningQualitySecu isDynamicReport check={check} />
          ) : (
            <TableEarningQualitySecu isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuEarningQualityThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuEarningQuality())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'FA082', ...detailItemCheck },
            { value: 'RT0060', ...detailItemCheck },
            { value: 'FA083', ...detailItemCheck },
            { value: 'RT0059', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'FA082', ...detailItemCheckTable },
            { value: 'FA083', ...detailItemCheckTable },
            { value: 'RT0059', ...detailItemCheckTable },
            { value: 'RTI0059', ...detailItemCheckTable },
            { value: 'RT0060', ...detailItemCheckTable },
            { value: 'RTI0060', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'EarningsQuality',
        },
      }
    case PANELS.LEVERAGE_SECU:
      return {
        renderComponent: ({ setting: { viewBy, checkTable, check } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendLeverageSecu isDynamicReport check={check} />
          ) : (
            <TableLeverageSecu isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuLeverageThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuLeverage())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0034', ...detailItemCheck },
            { value: 'FA084', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0034', ...detailItemCheckTable },
            { value: 'FA084', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'Leverage',
        },
      }
    case PANELS.FUNDING_AND_LIQUIDITY_SECU:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendFundingAndLiquiditySecu isDynamicReport check={check} />
          ) : (
            <TableFundingAndLiquiditySecu
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuFundingAndLiquidityThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuFundingAndLiquidity())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'RT0020', ...detailItemCheck },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.SHORT_AND_LONG_TEARM_FUNDING"
                  children={['FA085', 'FA086', 'FA087', 'FA088']}
                />
              ),
              children: [
                { value: 'FA085', ...detailItemCheck },
                { value: 'FA086', ...detailItemCheck },
                { value: 'FA087', ...detailItemCheck },
                { value: 'FA088', ...detailItemCheck },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'RT0020', ...detailItemCheckTable },
            { value: 'FA085', ...detailItemCheckTable },
            { value: 'FA086', ...detailItemCheckTable },
            { value: 'FA087', ...detailItemCheckTable },
            { value: 'FA088', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'FundingAndLiquidity',
        },
      }
    case PANELS.EARNINGS_BREAKDOWN_SECU:
      return {
        renderComponent: ({ setting: { viewBy, check, year, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendEarningBreakdownSecu isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearEarningBreakdownSecu isDynamicReport year={year} />
          ) : (
            <TableEarningBreakdownSecu
              isDynamicReport
              checkTable={checkTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuEarningBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuEarningBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'IS3', ...detailItemCheck },
            { value: 'IS6', ...detailItemCheck },
            { value: 'IS7', ...detailItemCheck },
            { value: 'IS4', ...detailItemCheck },
            { value: 'FA089', ...detailItemCheck },
            { value: 'IS13', ...detailItemCheck },
            { value: 'IS14', ...detailItemCheck },
            { value: 'IS16', ...detailItemCheck },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                { value: 'IS3', ...detailItemCheckRequire },
                { value: 'IS6', ...detailItemCheckRequire },
                { value: 'IS7', ...detailItemCheckRequire },
                { value: 'IS4', ...detailItemCheckRequire },
                { value: 'FA089', ...detailItemCheckRequire },
                { value: 'IS15', ...detailItemCheckRequire },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'IS3', ...detailItemCheckTable },
            { value: 'IS6', ...detailItemCheckTable },
            { value: 'IS7', ...detailItemCheckTable },
            { value: 'IS4', ...detailItemCheckTable },
            { value: 'FA089', ...detailItemCheckTable },
            { value: 'IS13', ...detailItemCheckTable },
            { value: 'IS14', ...detailItemCheckTable },
            { value: 'IS15', ...detailItemCheckTable },
            { value: 'IS16', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'EarningsBreakdown',
        },
      }
    case PANELS.BALANCE_SHEET_BREAKDOWN_SECU:
      return {
        renderComponent: ({
          setting: {
            viewBy,
            check,
            year,
            chartEachYear,
            tabTable,
            checkTable1,
            checkTable2,
            checkTable3,
          },
        }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendBalanceBreakdownSecu isDynamicReport check={check} />
          ) : viewBy === VIEW_BY.EACH_YEAR ? (
            <EachYearBalanceBreakdownSecu
              isDynamicReport
              year={year}
              chart={chartEachYear}
            />
          ) : (
            <TableBalanceBreakdownSecu
              isDynamicReport
              checkTable={[...checkTable1, ...checkTable2, ...checkTable3]}
              tab={tabTable}
            />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuBalanceBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuBalanceBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.EACH_YEAR, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.ASSET_STRUCTURE"
                  children={[
                    'FA090',
                    'BS250',
                    'BS265',
                    'BS36',
                    'BS46',
                    'BS49',
                    'FA091',
                    'RT0172',
                  ]}
                />
              ),
              children: [
                { value: 'FA090', ...detailItemCheck },
                { value: 'BS250', ...detailItemCheck },
                { value: 'BS265', ...detailItemCheck },
                { value: 'BS36', ...detailItemCheck },
                { value: 'BS46', ...detailItemCheck },
                { value: 'BS49', ...detailItemCheck },
                { value: 'FA091', ...detailItemCheck },
                { value: 'RT0172', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.LIABILITIES_STRUCTURE"
                  children={['BS66', 'BS81', 'FA099']}
                />
              ),
              children: [
                { value: 'BS66', ...detailItemCheck },
                { value: 'BS81', ...detailItemCheck },
                { value: 'FA099', ...detailItemCheck },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: (otherProps) => (
                <CheckboxParent
                  {...otherProps}
                  keySetting="check"
                  title="financialAnalysis.EQUITY_STRUCTURE"
                  children={[
                    'BS293',
                    'BS294',
                    'BS138',
                    'BS109',
                    'FA102',
                    'RT0173',
                  ]}
                />
              ),
              children: [
                { value: 'BS293', ...detailItemCheck },
                { value: 'BS294', ...detailItemCheck },
                { value: 'BS138', ...detailItemCheck },
                { value: 'BS109', ...detailItemCheck },
                { value: 'FA102', ...detailItemCheck },
                { value: 'RT0173', ...detailItemCheck },
              ],
            },
          ],
          [VIEW_BY.EACH_YEAR]: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => <Translate value="dynamicReport.SELECT_YEAR" />,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  renderItem: (props) => <SelectYear {...props} />,
                  style: { marginTop: 0 },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="dynamicReport.SELECT_INDICATOR" />
              ),
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 1,
                  title: 'financialAnalysis.ASSET_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA154', ...detailItemCheckRequire },
                    { value: 'FA092', ...detailItemCheckRequire },
                    { value: 'FA093', ...detailItemCheckRequire },
                    { value: 'FA094', ...detailItemCheckRequire },
                    { value: 'FA095', ...detailItemCheckRequire },
                    { value: 'FA096', ...detailItemCheckRequire },
                    { value: 'FA097', ...detailItemCheckRequire },
                    { value: 'FA098', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 2,
                  title: 'financialAnalysis.LIABILITIES_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA100', ...detailItemCheckRequire },
                    { value: 'FA101', ...detailItemCheckRequire },
                  ],
                },
                {
                  type: TYPE_INFORMATION_PANEL.CHECKBOX,
                  key: 'chartEachYear',
                  value: 3,
                  title: 'financialAnalysis.EQUITY_STRUCTURE',
                  isDisableMapTitle: true,
                  children: [
                    { value: 'FA160', ...detailItemCheckRequire },
                    { value: 'FA103', ...detailItemCheckRequire },
                    { value: 'FA104', ...detailItemCheckRequire },
                    { value: 'FA105', ...detailItemCheckRequire },
                    { value: 'FA106', ...detailItemCheckRequire },
                    { value: 'FA107', ...detailItemCheckRequire },
                  ],
                },
              ],
            },
          ],
          [VIEW_BY.TABLE]: [
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 0,
              title: 'financialAnalysis.ASSET_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'FA090', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS250', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS265', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS36', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS46', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS49', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'FA091', ...detailItemCheckTable, key: 'checkTable1' },
                { value: 'BS64', ...detailItemCheckTable, key: 'checkTable1' },
                {
                  value: 'RT0172',
                  ...detailItemCheckTable,
                  key: 'checkTable1',
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 1,
              title: 'financialAnalysis.LIABILITIES_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS66', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS81', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'BS65', ...detailItemCheckTable, key: 'checkTable2' },
                { value: 'FA099', ...detailItemCheckTable, key: 'checkTable2' },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'tabTable',
              value: 2,
              title: 'financialAnalysis.EQUITY_STRUCTURE',
              isDisableMapTitle: true,
              children: [
                { value: 'BS293', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS294', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS138', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS109', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'FA102', ...detailItemCheckTable, key: 'checkTable3' },
                { value: 'BS95', ...detailItemCheckTable, key: 'checkTable3' },
                {
                  value: 'RT0173',
                  ...detailItemCheckTable,
                  key: 'checkTable3',
                },
              ],
            },
          ],
          ratioGroupCode: 'BalanceSheetBreakdown',
        },
      }
    case PANELS.CASH_FLOW_STRUCTURE_SECU:
      return {
        renderComponent: ({ setting: { viewBy, check, checkTable } }) =>
          viewBy === VIEW_BY.TREND ? (
            <TrendCashBreakdownSecu isDynamicReport check={check} />
          ) : (
            <TableCashBreakdownSecu isDynamicReport checkTable={checkTable} />
          ),
        thunk: [
          ({ companyInfo, settingFs }) =>
            getSecuCashBreakdownThunk({
              organizationId: companyInfo.organizationId,
              ...settingFs,
            }),
        ],
        return: (dispatch) => {
          dispatch(resetStoreSecuCashBreakdown())
        },
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TREND, VIEW_BY.TABLE],
          [VIEW_BY.TREND]: [
            { value: 'CF19', ...detailItemCheck },
            { value: 'CF30', ...detailItemCheck },
            { value: 'CF37', ...detailItemCheck },
            { value: 'CF38', ...detailItemCheck },
          ],
          [VIEW_BY.TABLE]: [
            { value: 'CF19', ...detailItemCheckTable },
            { value: 'CF30', ...detailItemCheckTable },
            { value: 'CF37', ...detailItemCheckTable },
            { value: 'CF38', ...detailItemCheckTable },
          ],
          ratioGroupCode: 'CashFlowBreakdown',
        },
      }
    default:
      return {}
  }
}

export const getDefaultFinancialAnalysis = (companyType) => {
  const state = selectSliceFinancialAnalysis(store.getState())
  const panelList = getPanelListFinancialAnalysis(companyType)[0].children

  return state.panelId.map((id) => {
    const panelFA = state.panelById[id]
    const panelDynamicReport = panelList.find(
      ({ panel }) => panel === panelFA.key,
    )
    const check = panelDynamicReport?.setting?.check || []
    const extendCheck =
      panelFA.key === PANELS.LOAN_BOOK_BREAKDOWN_AND_COVERAGE_BANK
        ? ['top3Sector', 'lossToNpl', 'lossToTotalLoan']
        : panelFA.key === PANELS.FUNDING_AND_LIQUIDITY_SECU
        ? ['RT0020']
        : []

    return {
      id: getUnique(),
      screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS,
      panel: panelFA.key,
      label: panelFA.label,
      type: TYPE_ITEM_SETTING.PANEL,
      setting: {
        ...(panelDynamicReport?.setting || {}),
        viewBy: panelFA?.viewByActive,
        check: panelFA.setting?.checked
          ? panelFA.setting.checked
              .filter((item) => check.includes(item))
              .concat(extendCheck)
          : check,
        year: panelFA.setting?.year && +panelFA.setting?.year,
      },
    }
  })
}
